export enum ReferenceType {
    Navigation = 0,
    Dashboard = 1,
    Workflow = 2,
    ExternalLink = 3
}